import ContentManagementPageCard from './ContentManagementPageCard';

export default ContentManagementPageCard;
